import ReactMarkdown from "react-markdown"
import { ReactMarkdownOptions } from "react-markdown/lib/react-markdown"
import useGlobalStyles from "../../styles/globalStyles"

export const StyledMarkdown = (props: ReactMarkdownOptions) => {
  const globalStyles = useGlobalStyles()
  // you can provide a class name, but also include the markdown block class name
  const className = props.className ? `${props.className} ${globalStyles.markdownBlock}` : globalStyles.markdownBlock
  const withProps = { ...props, className: className }

  return (
    <ReactMarkdown linkTarget="_blank" {...withProps}>
      {props.children}
    </ReactMarkdown>
  )
}
